import { ApiDataAdapter } from '@internal-libraries/kheops-ui-lib'
import { ConfigurationCategoryAdapter } from './ConfigurationCategoryAdapter'
import { ConfigModule } from '../type/ConfigModule'
import { ConfigurationDto } from '../type/dto/ConfigurationDto'
import { GLOBAL_GROUP_KEY } from '../const'

export class ConfigurationModuleAdapter implements ApiDataAdapter<ConfigModule> {
    public createClass(configModule: ConfigurationDto): ConfigModule {
        const group = GLOBAL_GROUP_KEY === configModule.groupId ? GLOBAL_GROUP_KEY : parseInt(configModule.groupId)
        return {
            key: configModule.key,
            group: group,
            label: configModule.label,
            categories: Object.values(configModule._ref_categories).map(category =>
                new ConfigurationCategoryAdapter().createClass(category),
            ),
        }
    }
}
